import { useSession } from "@lululemon/auth-sdk";
import { useEffect } from "react";
export var useReloadShape = function (_a) {
    var shouldReload = _a.shouldReload;
    var loadShape = useSession().loadShape;
    useEffect(function () {
        if (shouldReload) {
            loadShape === null || loadShape === void 0 ? void 0 : loadShape();
        }
    }, [shouldReload]);
};
